import React from 'react';
import { Layout } from 'tea-component';
import componentMap from '@/pages/dashboard/_config/compConfig';
import MarketingPageWrap from '../MarketingPageWrap';
import StudioTabPrNoticeMarquee, {
  IStudioTabPrNoticeMarqueeConfig,
} from '../StudioTabPrNoticeMarquee';
import './index.scss';

const { Content } = Layout;

interface ICreativeTrendsWrapperConfig {
  componentName?: string;
  componentProps?: Record<string, unknown>;
  prNoticeMarquee?: IStudioTabPrNoticeMarqueeConfig;
}

interface ICreativeTrendsWrapperProps {
  config?: ICreativeTrendsWrapperConfig;
}

const CreativeTrendsWrapper: React.FC<ICreativeTrendsWrapperProps> = ({ config }) => {
  const { componentName = 'CreativeTrends', componentProps, prNoticeMarquee } = config || {};
  const marketingComponent = componentMap[componentName] as React.ComponentType<any> | undefined;

  return (
    <Content className="dbh-studio-creative-trends">
      <Content.Body full className="dbh-studio-creative-trends-body">
        {marketingComponent && (
          <MarketingPageWrap>
            <StudioTabPrNoticeMarquee
              tabKey="creativeTrends"
              prNoticeMarquee={prNoticeMarquee}
            />
            {React.createElement(marketingComponent, componentProps)}
          </MarketingPageWrap>
        )}
      </Content.Body>
    </Content>
  );
};

export default CreativeTrendsWrapper;
